import CancelIcon from '@mui/icons-material/Cancel';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';

const MediaHeader = ({ onClose, onZoomIn, onZoomOut, onReset, scale }) => {
    return (
        <div className="headerPostMedia">
            <button 
                onClick={onClose} 
                title="Close (Esc)"
            >
                <CancelIcon />
            </button>

            <button 
                onClick={onZoomIn} 
                title="Zoom In"
            >
                <ZoomInIcon />
            </button>

            <button 
                onClick={onZoomOut} 
                disabled={scale <= 1} 
                title="Zoom Out"
            >
                <ZoomOutIcon style={{ opacity: scale <= 1 ? 0.5 : 1 }} />
            </button>

            <button 
                onClick={onReset} 
                title="Reset Zoom"
            >
                <ZoomOutMapIcon />
            </button>
        </div>
    );
};
export default MediaHeader;